/**
 * "+15128675309" → "(512) 867-5309".
 * Returns the input unchanged if it isn't a 10-digit US number.
 */
export function formatUsPhone(e164: string | null | undefined): string {
  const digits = (e164 ?? '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  if (digits.length !== 10) return e164 ?? '';
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
